<template>
  <table class="table">
    <tbody>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.status') }}:</strong>
          </h6>
          <el-tag :type="getStatusTagType(pqrData.status)">
            <span style="text-transform: capitalize">{{ pqrData.status }}</span>
          </el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.type') }}:</strong>
          </h6>
          <span style="text-transform: capitalize">{{ pqrData.type }}</span>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('pqr.client') }}:</strong>
          </h6>
          {{ isFromCreate ? pqrData.clientSelected : pqrData.clients.name }}
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.email') }}:</strong>
          </h6>
          <template v-if="isSet(pqrData.email)">
            <div class="row">
              <div class="col-6 pt-1">
                {{ pqrData.email }}
              </div>
              <div class="col-6">
                {{ $t('pqr.send_notifications_questionmark') }}
                <el-tag type="info">
                  {{
                    pqrData.send_user_notification
                      ? $t('common_words.yes')
                      : $t('common_words.no')
                  }}
                </el-tag>
              </div>
            </div>
          </template>
          <el-tag type="warning" v-else>{{
            $t('common_words.no_assigned')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('pqr.reception_date') }}:</strong>
          </h6>
          {{ this.formatDate(pqrData.reception_date) }}
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('pqr.reception_week') }}:</strong>
          </h6>
          {{ pqrData.reception_week }}
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('pqr.reception_method') }}:</strong>
          </h6>
          <span style="text-transform: capitalize">{{
            pqrData.receiving_method
          }}</span>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.farms2') }}:</strong>
          </h6>
          <template v-if="isFromCreate"
            ><el-tag
              type="info"
              v-for="(farm, index) in pqrData.farmsSelected"
              :key="index"
            >
              {{ farm }}
            </el-tag>
          </template>
          <template v-else>
            <el-tag
              type="info"
              v-for="(farm, index2) in pqrData.farm"
              :key="index2"
            >
              {{ farm.name }}
            </el-tag>
          </template>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.company') }}:</strong>
          </h6>
          <el-tag type="info">
            {{
              isFromCreate ? pqrData.businessSelected : pqrData.business.name
            }}
          </el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('pqr.week_cut') }}:</strong>
          </h6>
          <template v-if="isSet(pqrData.cutting_week)">
            {{ pqrData.cutting_week }}
          </template>
          <el-tag type="warning" v-else>{{
            $t('common_words.no_assigned')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('pqr.week_arrival') }}:</strong>
          </h6>
          <template v-if="isSet(pqrData.arrival_week)">
            {{ pqrData.arrival_week }}
          </template>
          <el-tag type="warning" v-else>{{
            $t('common_words.no_assigned')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.reference') }}:</strong>
          </h6>
          <el-tag type="info">
            {{ isFromCreate ? pqrData.boxSelected : pqrData.box.name }}
          </el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('pqr.quantity_in_boxes') }}:</strong>
          </h6>
          <template v-if="isSet(pqrData.boxes_quantity)">
            {{ this.formatNumber(Number(pqrData.boxes_quantity)) }}
          </template>
          <el-tag type="warning" v-else>{{
            $t('common_words.no_assigned')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong
              >{{ $t('common_words.date') }}
              {{ $t('pqr.credit_note') }}:</strong
            >
          </h6>
          <template v-if="isSet(pqrData.date_credit_note)">
            {{ this.formatDate(pqrData.date_credit_note) }}
          </template>
          <el-tag type="warning" v-else>{{
            $t('common_words.no_assigned')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <template>
            <h6 class="mb-2">
              <strong>{{ $t('pqr.container_number_id') }}:</strong>
            </h6>
            {{
              isFromCreate
                ? pqrData.container_num
                : formatContainerNumber(
                    pqrData.containers[0].pivot.container_num
                  )
            }}
          </template>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <template v-if="isFromCreate">
            <h6 v-if="!isSet(pqrData.thermograph_num)" class="mb-2">
              <strong>{{ $t('pqr.thermograph_number') }}:</strong>
            </h6>
            <template v-if="isSet(pqrData.thermograph_num)">
              <div class="row">
                <div class="col-6">
                  <h6 class="mb-2">
                    <strong>{{ $t('pqr.thermograph_number') }}:</strong>
                  </h6>
                  {{ pqrData.thermograph_num }}
                </div>
                <div class="col-6">
                  <h6 class="mb-2">
                    <strong>{{ $t('climate.temperature_type') }}</strong>
                  </h6>
                  <span style="text-transform: capitalize">{{
                    pqrData.type_temperature
                  }}</span>
                </div>
              </div>
            </template>
            <el-tag type="warning" v-else>{{
              $t('common_words.no_assigned')
            }}</el-tag>
          </template>
          <template v-else>
            <h6
              v-if="
                !(
                  pqrData.containers &&
                  pqrData.containers[0].pivot.thermograph_num
                )
              "
              class="mb-2"
            >
              <strong>{{ $t('pqr.thermograph_number') }}:</strong>
            </h6>
            <template
              v-if="
                pqrData.containers &&
                pqrData.containers[0].pivot.thermograph_num
              "
            >
              <div class="row">
                <div class="col-6">
                  <h6 class="mb-2">
                    <strong>{{ $t('pqr.thermograph_number') }}:</strong>
                  </h6>
                  {{ pqrData.containers[0].pivot.thermograph_num }}
                </div>
                <div class="col-6">
                  <h6 class="mb-2">
                    <strong>{{ $t('climate.temperature_type') }}</strong>
                  </h6>
                  <div class="col-6">
                    <span style="text-transform: capitalize">{{
                      pqrData.containers[0].pivot.type_temperature
                    }}</span>
                  </div>
                </div>
              </div>
            </template>
            <el-tag type="warning" v-else>{{
              $t('common_words.no_assigned')
            }}</el-tag>
          </template>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('pqr.farm_container') }}:</strong>
          </h6>
          <template v-if="isFromCreate"
            ><el-tag
              type="info"
              v-for="(farm, index) in pqrData.farmsContainerSelected"
              :key="index"
            >
              {{ farm }}
            </el-tag>
          </template>
          <template v-else>
            <el-tag
              type="info"
              v-for="(farm, index2) in pqrData.containers"
              :key="index2"
            >
              {{ farm.name }}
            </el-tag>
          </template>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('pqr.reason') }}:</strong>
          </h6>
          {{ pqrData.reason }}
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('pqr.action_plan') }}:</strong>
          </h6>
          <template v-if="isSet(pqrData.action_plan)">
            {{ pqrData.action_plan }}
          </template>
          <el-tag type="warning" v-else>{{
            $t('common_words.no_assigned')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.observations') }}:</strong>
          </h6>
          <template v-if="isSet(pqrData.observations)">
            {{ pqrData.observations }}
          </template>
          <el-tag type="warning" v-else>{{
            $t('common_words.no_assigned')
          }}</el-tag>
        </td>
      </tr>
      <tr class="shadow-sm">
        <td>
          <h6 class="mb-2">
            <strong>{{ $t('common_words.files') }}:</strong>
          </h6>
          <template v-if="isFromCreate">
            <div>
              <template v-if="pqrData.fileList && pqrData.fileList.length > 0">
                <el-tag
                  type="info"
                  v-for="(filePqr, index) in pqrData.fileList"
                  :key="index"
                >
                  {{ filePqr }}
                </el-tag>
              </template>
              <el-tag type="warning" v-else>{{
                $t('common_words.no_assigned')
              }}</el-tag>
            </div>
          </template>
          <template v-else>
            <div>
              <template v-if="isSet(pqrData.evidence)">
                <a
                  style="cursor: pointer"
                  v-for="(filePqr, index) in pqrData.fileList"
                  :key="index"
                  @click="handleDownload(pqrData.evidence, filePqr)"
                >
                  <el-tag type="info">
                    <em class="fa fa-solid fa-download"></em>
                    {{ filePqr }}
                  </el-tag>
                </a>
              </template>
              <el-tag type="warning" v-else>{{
                $t('common_words.no_assigned')
              }}</el-tag>
            </div>
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { DISK_URL } from 'src/util/Util';
import { isset } from 'src/util/Util.js';
import Formatter from 'src/class/Formatter';
import mixinMasters from 'src/util/mixinMasters';
import moment from 'moment';

export default {
  name: 'pqr-details-table',
  props: {
    pqrData: {
      type: Object,
      default: null,
    },
    isFromCreate: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [mixinMasters],

  methods: {
    getStatusTagType(status) {
      switch (status) {
        case 'abierto':
          return 'primary';
        case 'en proceso':
          return 'warning';
        case 'cerrado':
          return 'info';
        default:
          return '';
      }
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },

    formatNumber(value) {
      return Formatter.formatNumber(Number(value));
    },

    formatMoney(value) {
      return Formatter.formatMoney(Number(value));
    },

    handleDownload(folder, fileName) {
      const diskName = 'pqr_evidences';
      const url = `${DISK_URL}${diskName}/${folder}/${encodeURIComponent(
        fileName
      )}`;
      window.open(url, '_blank');
    },

    isSet(data) {
      return isset(data);
    },

    formatContainerNumber(containerNum) {
      const prefijo = containerNum.slice(0, 4);
      const num = containerNum.slice(4, 10);
      const sufijo = containerNum.slice(10, 11);

      const res = `${prefijo} ${num}-${sufijo}`;

      return res;
    },
  },
};
</script>
